<template>
  <div>
    <!-- 헤더 / web	-->
    <div id="head" v-if="!IS_MOBILE">
      <h1 class="logo">
        <router-link to="/">송원문화재단</router-link>
      </h1>

      <!--     -->
      <!-- gnb + active 시 메뉴 슬라이드 열림 -->
      <!-- gnb + active + off 시 메뉴 슬라이드 닫힘 -->

      <!--	메뉴	-->
      <div id="gnb_area">
        <ul
          class="gnb"
          :class="{ active: cssGnb, off: offCss }"
          @mouseover="showCssGnb(true)"
        >
          <li>
            <a>주요사업</a>
            <div class="gnb_list first">
              <ul>
                <li @click="cssGnb = false">
                  <router-link to="/business/educationsupport">주요사업</router-link>
                </li>
                <!-- <li @click="cssGnb = false">
                  <router-link to="/business/planningbusiness">기획사업</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/business/scholarshipselection">교육학술후원</router-link>
                </li> -->
              </ul>
            </div>
          </li>
          <li>
            <a>재단소식</a>
            <div class="gnb_list">
              <ul>
                <li @click="cssGnb = false">
                  <router-link to="/notice/noticelist">
                    공지사항
                  </router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/notice/newslist">
                    소식
                  </router-link>
                </li>
                <li v-if="IS_ADMIN" @click="cssGnb = false">
                    <router-link to="/notice/bannerlist">
                      배너
                    </router-link>
                </li>
                <li v-if="IS_ADMIN" @click="cssGnb = false">
                    <router-link to="/notice/popupList">
                      팝업공지
                    </router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a>재단소개</a>
            <div class="gnb_list">
              <ul>
                <li @click="cssGnb = false">
                  <router-link to="/intro/establishment">설립취지</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/intro/history">연혁</router-link>
                </li>
                <li @click="cssGnb = false">
                  <router-link to="/intro/location">오시는길</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a>유관기관</a>
            <div class="gnb_list">
              <ul>
                <li @click="cssGnb = false">
                  <a href="https://songwonart.org/" target="_blank">
                    송원아트센터
                  </a>
                </li>
                <li @click="cssGnb = false" >
                  <a href="https://home.pen.go.kr/" target="_blank">
                    부산남부교육지원청
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div class="gnb_bg" @mouseover="showCssGnb(false)"></div>
      </div>
      <!--미사용으로 인해 주석처리 2026.05-->
      <!-- <div class="shortcut" v-if="IS_ADMIN">
        <a href="https://mgnt.dkfd.org" target="_blank">
          장학시스템 바로가기
          <img :src="require('./../../assets/img/arrow-right-circle.png')">
        </a>
      </div> -->
    </div>

    <div id="M_head" :class="{ on: mBtnMenu }" v-if="IS_MOBILE">
      <button class="M_gnb_btn" @click="mBtnMenu = !mBtnMenu">gnb</button>
      <h1 class="M_logo"><a href="/" class="router-link-active">송원문화재단</a></h1>

      <!--	메뉴	-->
      <div id="M_gnb_area">
        <ul class="M_gnb">
          <li>
            <!--  class="active" 추가시 M_gnb_list 오픈 -->
            <a
              @click="btnMobileSubMenu('mSub01')"
              :class="{ active: mSub01 }"
              >주요사업</a
            >
            <div class="M_gnb_list">
              <ul>
                <li @click="mBtnMenu = false">
                  <router-link to="/business/educationsupport">주요사업</router-link>
                </li>
                <!-- <li @click="mBtnMenu = false">
                  <router-link to="/business/planningbusiness">기획사업</router-link>
                </li>
                <li @click="mBtnMenu = false">
                  <router-link to="/business/scholarshipselection">교육학술후원</router-link>
                </li> -->
              </ul>
            </div>
          </li>
          <li>
            <a
              @click="btnMobileSubMenu('mSub02')"
              :class="{ active: mSub02 }"
              >재단소식</a
            >
            <div class="M_gnb_list">
              <ul>
                <li @click="mBtnMenu = false">
                  <router-link to="/notice/noticelist">
                    공지사항
                  </router-link>
                </li>
                <li @click="mBtnMenu = false">
                  <router-link to="/notice/newslist">
                    소식
                  </router-link>
                </li>

              </ul>
            </div>
          </li>
          <li>
            <a
              @click="btnMobileSubMenu('mSub03')"
              :class="{ active: mSub03 }"
              >재단소개</a
            >
            <div class="M_gnb_list">
              <ul>
                <li @click="mBtnMenu = false">
                  <router-link to="/intro/establishment">설립취지</router-link>
                </li>
                <li @click="mBtnMenu = false">
                  <router-link to="/intro/history">연혁</router-link>
                </li>
                <li @click="mBtnMenu = false">
                    <router-link to="/intro/location">오시는길</router-link>
                  </li>

              </ul>
            </div>
          </li>
          <li>
            <a
              @click="btnMobileSubMenu('mSub04')"
              :class="{ active: mSub04 }"
              >유관기관</a
            >
            <div class="M_gnb_list">
              <ul>
                <li @click="cssGnb = false">
                  <a href="https://songwonart.org/" target="_blank">
                    송원아트센터
                  </a>
                </li>
                <li @click="cssGnb = false" >
                  <a href="https://home.pen.go.kr/" target="_blank">
                    부산남부교육지원청
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue2Filters from "vue2-filters";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  mixins: [Vue2Filters.mixin],
  data: () => ({
    message: "Header.vue",
    cssGnb: false,
    offCss: false,
    mBtnMenu: false,
    isMobile: false,
    mSub01: false,
    mSub02: false,
    mSub03: false,
    mSub04: false,
    windowWidth: 0,
    windowHeight: 0,
    showLangList: false
  }),
  methods: {
    showCssGnb(bShow) {

      if (bShow) {
        this.offCss = false;
        this.cssGnb = true;
      }

      if (bShow == false) {
        this.bHeaderShowDelay = true;
        this.offCss = true;
        // this.cssGnb = false;
      }
    },
    btnMobileSubMenu(btnIndex) {
      switch (btnIndex) {
        case "mSub01":
          {
            this.mSub01 = !this.mSub01;
            this.mSub02 = false;
            this.mSub03 = false;
            this.mSub04 = false;
          }
          break;
        case "mSub02":
          {
            this.mSub01 = false;
            this.mSub02 = !this.mSub02;
            this.mSub03 = false;
            this.mSub04 = false;
          }
          break;
        case "mSub03":
          {
            this.mSub01 = false;
            this.mSub02 = false;
            this.mSub03 = !this.mSub03;
            this.mSub04 = false;
          }
          break;
        case "mSub04":
          {
            this.mSub01 = false;
            this.mSub02 = false;
            this.mSub03 = false;
            this.mSub04 = !this.mSub04;
          }
          break;
      }
    }
  },
  computed: {
    ...mapGetters(["getAdmin",]),
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    },
    IS_ADMIN() {
      return this.getAdmin;
    },
  },
  mounted() {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue